import React from 'react';
import { Segment, Image } from "semantic-ui-react";

const imgPath = './assets/images/misc/brian_intro.jpg';

const segmentStyle = {
    background: 'none',
    boxShadow: 'none',
};

const Intro = () => {
    return (
        <Segment style={segmentStyle}>
            <Image className='intro-style' src={imgPath} />
        </Segment>
    );
};

export default Intro;